import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  error: undefined,
  selectable: false,
  selectedRowKeys: [],
  selectedRows: [],
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  const { list } = store.state.admin.pacs;

  store.setState((state) => {
    state.admin.pacs.list.busy = true;
    state.admin.pacs.list.filters = {
      ...state.admin.pacs.list.filters,
      ...meta,
    };
  });

  try {
    const params = {
      limit: meta.limit || list.pagination.limit,
      page: meta.page || list.filters.page,
      ...meta,
    };

    const response = await Http.get('api/pacs', { params });

    store.setState((state) => {
      state.admin.pacs.list.busy = false;
      state.admin.pacs.list.data = response.data;
      state.admin.pacs.list.pagination = {
        ...state.admin.pacs.list.pagination,
        ...response.meta.pagination,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.pacs.list.error = error.data || error;
      state.admin.pacs.list.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.admin.pacs.list.error = undefined;
};

const setSelectable = (store, selectable) => (state) => {
  state.admin.pacs.list.selectable = selectable;
};

const setSelection = (store, selectedRows, selectedRowKeys) => {
  return (state) => {
    state.admin.pacs.list = {
      ...state.admin.pacs.list,
      selectedRows: selectedRows,
      selectedRowKeys: selectedRowKeys,
    };
  };
};

const clearSelection = () => {
  return (state) => {
    state.admin.pacs.list = {
      ...state.admin.pacs.list,
      selectable: false,
      selectedRowKeys: [],
      selectedRows: [],
    };
  };
};

const actions = {
  paginate,
  resetError,
  setSelectable,
  setSelection,
  clearSelection,
};

const PacsListStore = {
  state: () => initialState,
  actions,
};

export default PacsListStore;
